import React from 'react';
import { motion } from 'framer-motion';

export default function Messages() {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center mb-8">
        <div>
          <h2 className="text-2xl font-black text-white" style={{ fontFamily: 'Raleway, sans-serif' }}>Mesaj Kutusu</h2>
          <p className="text-zinc-400 text-sm mt-1">Müşterilerden gelen form ve iletişim talepleri.</p>
        </div>
        <button className="bg-zinc-800 hover:bg-zinc-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors flex items-center gap-2">
          <i className="ri-refresh-line"></i> Yenile
        </button>
      </div>

      <motion.div 
        initial={{ opacity: 0, scale: 0.98 }}
        animate={{ opacity: 1, scale: 1 }}
        className="bg-zinc-900 border border-zinc-800 rounded-2xl overflow-hidden"
      >
        <div className="p-8 text-center bg-zinc-900/50">
           <i className="ri-inbox-archive-line text-6xl text-zinc-700 mb-4 block"></i>
           <h3 className="text-xl font-bold text-white mb-2">Henüz Mesaj Yok</h3>
           <p className="text-zinc-500 max-w-md mx-auto">
             Firebase veritabanı bağlantısı kuruldu. Ön yüzdeki iletişim formu doldurulduğunda mesajlar burada listelenecek.
           </p>
        </div>
      </motion.div>
    </div>
  );
}
